<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                          :href="route('attendee-import.index', [eventInfo.id])">Attendee Imports
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Create Auto Import
        </h1>
        <form @submit.prevent="store">
            <card class="full-w">
                <template v-slot:header>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Create Auto
                        Import
                    </loading-button>
                </template>

                <div class="p-6 flex flex-wrap">
                    <select-input v-model="form.import_source_id" :error="form.errors.import_source_id"
                                  class="pr-6 pb-4 lg:w-1/2" label="Import Source">
                        <option v-for="e in importSources" :key="e.id" :value="e.id" v-text="e.name"></option>
                    </select-input>
                    <select-input v-model="form.form_id" :error="form.errors.form_id"
                                  :disabled="form.import_source_id === null" class="pr-6 pb-4 lg:w-1/2" label="Form">
                        <option v-for="e in importSourceForms" :key="e.id" :value="e.id" v-text="e.name"></option>
                    </select-input>
                </div>
            </card>

            <table-wrapper :headers="['ID', 'Name', 'Label', 'Mapped Field', 'Attendee']" :text-wrap="false"
                           class="mb-4">
                <table-row v-for="field in form.fields" :key="field.id">
                    <table-cell>{{ field.id }}</table-cell>
                    <table-cell>{{ field.name }}</table-cell>
                    <table-cell :title="field.label">{{
                            truncate(field.label, {length: 40, separator: ' '})
                        }}
                    </table-cell>
                    <table-cell>
                        <select-input v-model="field.table_field" class="w-full">
                            <option></option>
                            <optgroup v-for="fieldGroup in fieldOptions" :label="fieldGroup.group"
                                      :key="fieldGroup.group">
                                <option v-for="field in fieldGroup.fields" :key="field" :value="field"
                                        v-text="field"></option>
                            </optgroup>
                        </select-input>
                    </table-cell>
                    <table-cell colspan="2">
                        <select-input v-model="field.record_index" class="w-full">
                            <option :value="0">Primary Attendee</option>
                            <option :value="1">Guest #1</option>
                            <option :value="2">Guest #2</option>
                            <option :value="3">Guest #3</option>
                            <option :value="4">Guest #4</option>
                        </select-input>
                    </table-cell>
                </table-row>
            </table-wrapper>
        </form>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Card from "@/Shared/Card/Card";
import {Inertia} from '@inertiajs/inertia'
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import TableCellEnd from "@/Shared/Table/TableCellEnd"
import truncate from 'lodash/truncate'

export default {
    metaInfo: {title: 'Create Auto Import'},
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        Card,
        TableWrapper,
        TableRow,
        TableCell,
        TableCellEnd
    },
    layout: Layout,
    remember: 'form',
    props: {
        eventInfo: Object,
        importSources: Array,
        importSourceForms: Array,
        attendeeAutoImport: Object,
        fieldOptions: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                import_source_id: this.attendeeAutoImport.import_source_id,
                form_id: this.attendeeAutoImport.form_id,
                fields: this.attendeeAutoImport.fields,
            }),
        }
    },
    computed: {
        selectedImportSourceId() {
            return this.form.import_source_id
        },
        selectedFormId() {
            return this.form.form_id
        },
    },
    watch: {
        selectedImportSourceId() {
            Inertia.visit(route('attendee-auto-import.create', {
                id: this.eventInfo.id,
                import_source: this.form.import_source_id
            }), {
                only: ['importSourceForms', 'attendeeAutoImport'],
                preserveScroll: true,
            })
        },
        selectedFormId() {
            Inertia.visit(route('attendee-auto-import.create', {
                id: this.eventInfo.id,
                import_source: this.form.import_source_id,
                form: this.form.form_id
            }), {
                only: ['importSourceForms', 'attendeeAutoImport'],
                preserveScroll: true,
            })
        }
    },
    methods: {
        truncate,
        store() {
            this.form.transform((data) => ({
                ...data,
                event_id: this.eventInfo.id,
            })).post(this.route('attendee-auto-import.store'))
        }
    },
}
</script>
